import React from "react";
import wave from "./wave.svg";
import Aos from 'aos';
import { useEffect } from "react";
import 'aos/dist/aos.css'
import image from "../bush.jpeg"
export default function App() {
  useEffect(()=>{
    Aos.init({
      offset: 120,
      duration: 1000
    });
  },[])
  return (
    <>
      <section style={{
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }} className=" bg-[#0d2832]">
        {/* <svg
          id="about"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="#f1f5f8"
            fill-opacity="1"
            d="M0,160L40,165.3C80,171,160,181,240,176C320,171,400,149,480,122.7C560,96,640,64,720,90.7C800,117,880,203,960,224C1040,245,1120,203,1200,165.3C1280,128,1360,96,1400,80L1440,64L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"
          ></path>
        </svg> */}
        <section class="text-gray-600 body-font">
          <div id="about" class="container px-5 py-24 mx-auto ">
            <h1 data-aos="fade-up" className="sm:text-6xl text-3xl font-bold mb-4 text-[#efeee9] font-serif pt-8  pb-5 flex justify-center items-center">
              About me
            </h1>
            <div class="flex ">
              <div class="p-4 ">
                <div class="h-full bg-[#efeee8] p-8 rounded" data-aos="flip-up">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="block w-5 h-5 text-gray-700 mb-4"
                    viewBox="0 0 975.036 975.036"
                  >
                    <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
                  </svg>
                  <p class="leading-relaxed mb-6 text-gray-700 bg-[#efeee8]" >
                  I turn complex problems into elegant solutions with a dash of caffeine and a sprinkle of creativity. <br/>
              As an aspiring software engineer with a passion for developing innovative and user-friendly solutions, I am currently pursuing a Bachelor's degree in Computer Science from Vellore Institute of Technology, Vellore. Through my studies, I have gained experience in various programming languages and software development methodologies. I am eager to continue learning and growing as a software engineer and am open to opportunities that will allow me to do so. 
              Feel free to connect with me on LinkedIn and learn more about my experience and interests. I am always open to networking and learning from others in the industry.
                  </p>
                  <a class="inline-flex items-center">
                    <span class="flex-grow flex flex-col ">
                      <span class="title-font font-medium text-gray-900">
                        VARUN SOOD
                      </span>
                      <span class="text-gray-500 text-sm">DEVELOPER</span>
                    </span>
                  </a>
                </div>
              </div>
            
            </div>
          </div>
        </section>
        {/* <div  className=''></div>
        <section className="text-gray-600 font-mono">
        <div className="container mx-auto flex px-5  items-center justify-center flex-col">
          <div className="text-center lg:w-2/3 w-full">
            <h1 className="font-link sm:text-6xl text-3xl mb-4 font-medium text-[#F6BE00] p-8">About me</h1>
            <p className="mb-6 text-[#f1f5f8] sm:text-lg leading-relaxed">I turn complex problems into elegant solutions with a dash of caffeine and a sprinkle of creativity. <br/>
              As an aspiring software engineer with a passion for developing innovative and user-friendly solutions, I am currently pursuing a Bachelor's degree in Computer Science from Vellore Institute of Technology, Vellore. Through my studies, I have gained experience in various programming languages and software development methodologies. I am eager to continue learning and growing as a software engineer and am open to opportunities that will allow me to do so. 
              Feel free to connect with me on LinkedIn and learn more about my experience and interests. I am always open to networking and learning from others in the industry.</p>
          </div>
        </div>
      </section> */}
      </section>
    </>
  );
}
